<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '600px' }"
  styleClass="create-commessa-dialog"
  (onHide)="closeDialog()"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="dialog-title">
        <i class="pi pi-briefcase dialog-icon"></i>
        <h2>Nuova Commessa</h2>
      </div>
    </div>
  </ng-template>

  <div class="dialog-content">
    <div class="form-container">
      <!-- Campo Codice -->
      <div class="form-field">
        <label for="codice">
          Codice
          <span class="required">*</span>
        </label>
        <input
          id="codice"
          type="text"
          pInputText
          [(ngModel)]="codice"
          placeholder="Inserisci il codice della commessa"
          [style]="{ width: '100%' }"
          [disabled]="saving"
          (keydown.enter)="isFormValid() && saveCommessa()"
        />
        <small class="p-error" *ngIf="codice.trim() && codiceEsiste()">
          Esiste già una commessa con questo codice
        </small>
        <small class="p-help-text" *ngIf="codice.trim() && !codiceEsiste()">
          ✓ Codice disponibile
        </small>
      </div>

      <!-- Campo Descrizione -->
      <div class="form-field">
        <label for="descrizione">
          Descrizione
          <span class="required">*</span>
        </label>
        <textarea
          id="descrizione"
          pInputTextarea
          [(ngModel)]="descrizione"
          placeholder="Inserisci la descrizione della commessa"
          [rows]="3"
          [style]="{ width: '100%' }"
          [disabled]="saving"
        ></textarea>
      </div>

      <!-- Campo Cliente -->
      <div class="form-field">
        <label for="clienteId">
          Cliente
          <span class="required">*</span>
        </label>
        <p-dropdown
          id="clienteId"
          [options]="clientiOptions"
          [(ngModel)]="clienteId"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleziona un cliente"
          [style]="{ width: '100%' }"
          [disabled]="saving || loadingClienti"
          [loading]="loadingClienti"
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          [appendTo]="'body'"
          [overlayOptions]="{ baseZIndex: 2200000 }"
          emptyMessage="Nessun cliente disponibile"
          emptyFilterMessage="Nessun risultato"
        >
          <ng-template let-cliente pTemplate="item">
            <div class="cliente-dropdown-item">
              <i class="pi pi-building"></i>
              <span>{{ cliente.label }}</span>
            </div>
          </ng-template>
          <ng-template let-cliente pTemplate="selectedItem">
            <div class="cliente-selected-item" *ngIf="cliente">
              <i class="pi pi-building"></i>
              <span>{{ cliente.label }}</span>
            </div>
          </ng-template>
        </p-dropdown>
        <small class="p-help-text" *ngIf="clienti.length === 0 && !loadingClienti">
          ⚠️ Nessun cliente disponibile. Crea prima un cliente.
        </small>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        (click)="closeDialog()"
        [disabled]="saving"
      ></button>
      <button
        pButton
        type="button"
        label="Crea Commessa"
        icon="pi pi-check"
        class="p-button-primary"
        (click)="saveCommessa()"
        [disabled]="!isFormValid() || saving"
        [loading]="saving"
      ></button>
    </div>
  </ng-template>
</p-dialog>
